


export const SmsTemplate_START = 'SmsTemplate_START';
export const SmsTemplate_END = 'SmsTemplate_END';
export const SmsTemplate_ERROR = 'SmsTemplate_ERROR';
export const SmsTemplate_SUCCESS = 'SmsTemplate_SUCCESS';
export const SmsTemplate_FAIL = 'SmsTemplate_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully'